export default __webpack_public_path__ + "static/media/toggle-expand.4bd50a1d.png";